import * as React from "react";
import { ODataParams, Query } from "../../Components/Query";
import DocumentTitle from "../../misc/components/DocumentTitle";
import { DiarySessionTable } from "./DiarySessionTable";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";

export const DiarySessionList = () => {

    const { study } = useCurrentStudyConfigurationContext();
    const client = useWebPortalApiClient();

    const handleRefresh = async (params: ODataParams) => {

        let filter = params.filter ? `(${params.filter}) and ` : '';
        filter += `visit/subject/site/study/id eq ${study.id}`;

        return await client.client.getDiarySessions(undefined, filter, params.orderby, undefined, params.top, params.skip, 'groupby((visit/subject/site/study/id,visit/subject/site/study/name,visit/subject/site/id,visit/subject/site/number,visit/subject/id,visit/subject/number), aggregate($count as sessionCount, occurred with max as lastSession))');
    }

    return (
        <DocumentTitle title="Diary Sessions | Vitalograph Web Portal">
            <Query onRefresh={handleRefresh} initialOrdering={[{ field: "lastSession", condition: "desc" }]}>
                <DiarySessionTable />
            </Query>
        </DocumentTitle>
    );
}
